import { render } from "./SearchProduct.vue?vue&type=template&id=66a9feee&scoped=true"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"

import "./SearchProduct.vue?vue&type=style&index=0&id=66a9feee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a9feee"]])

export default __exports__